import { FC, SVGProps } from "react";

const SuccessBanner: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg viewBox="0 0 69 64" fill="currentcolor" {...props}>
      <path
        d="M23.8364 64L17.8773 54.2476L6.58636 51.8095L7.68409 40.5333L0 32L7.68409 23.4667L6.58636 12.1905L17.8773 9.75238L23.8364 0L34.5 4.41905L45.1636 0L51.1227 9.75238L62.4136 12.1905L61.3159 23.4667L69 32L61.3159 40.5333L62.4136 51.8095L51.1227 54.2476L45.1636 64L34.5 59.5809L23.8364 64ZM31.2068 42.819L48.9273 25.6L44.5364 21.181L31.2068 34.1333L24.4636 27.7333L20.0727 32L31.2068 42.819Z"
      />
    </svg>
  );
};

export default SuccessBanner;
